export default __webpack_public_path__ + "media/music/3405bbfb0a14a92586f3949dff9bfc36.mp3";